export const EXTRAORDINARY_PAP = "extraordinary";

/** Only leaders in the US can open an extraordinary PAP, so only they get the button. */
export function canStartExtraordinaryPap(jurisdiction) {
  return jurisdiction === "US";
}

/**
 * Whether the Team PAPs menu entry shows. Everyone else sees it only while a
 * report has an open PAP (`openPapCount` is null until fetched, so it fails open);
 * a US leader sees it all the time, to open an extraordinary PAP whenever needed.
 */
export function showTeamPapsLink({ openPapCount, jurisdiction }) {
  return canStartExtraordinaryPap(jurisdiction) || openPapCount !== 0;
}

export function isExtraordinaryPap(pap) {
  return pap?.origin === EXTRAORDINARY_PAP;
}
